<template>
  <Container type="card-full">
      <div id="box">
        <div v-for="(item, index) in list" :key="item.pexpertid" class="box">
            <div class="h">
                <div class="h-item">序号</div>
                <div class="h-item">项目编号</div>
                <div class="h-item">项目名称</div>
                <div class="h-item">评审人号码</div>
                <div class="h-item">评审人密码</div>
                <div class="h-item">类型</div>
                <div class="h-item">角色</div>
            </div>
            <div class="b">
                <div class="b-item">{{index+1}}</div>
                <div class="b-item">{{item.projectcode}}</div>
                <div class="b-item">{{item.projectname}}</div>
                <div class="b-item">{{item.pexpertlogincode}}</div>
                <div class="b-item">{{item.pexpertloginpwd}}</div>
                <div class="b-item">{{item.pexperttypedesc}}</div>
                <div class="b-item">{{item.pexpertroletypedesc}}</div>
            </div>
        </div>
      </div>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  export default {
    name: 'printingPreview',
    data () {
      return {
          list:[]
      }
    },
    mounted(){
        this.getExpertList()
    },
    methods: {
        init(){
            this.list = this.$route.query.list
        },
        async getExpertList(){
            this.list = await request({
                url: '/xmgl/project/getPexpertList',
                method: "get",
                params: {projectid: this.$route.query.projectid}
            })
        }
    }
  }
</script>
<style lang="scss" scoped>
#box{
    width: 100%;
}
.box{
    margin: 20px auto;
    border: 1px solid #d1dbe5;
    text-align: center;
}
.h{
    display: flex;
}
.h:first-child{
    border-bottom: 1px solid #d1dbe5;
    justify-content: space-around;
}
.h-item{
    flex: 1;
    border-right: 1px solid #d1dbe5;
}
.h-item:last-child{
    border-right: 0;
}
.b{
    display: flex;
    justify-content: space-around;
}
.b-item{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #d1dbe5;
}
.b-item:last-child{
    border-right: 0;
}
.container-component{
    top:72px;
}
</style>
